




















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Title from "./title.vue";
import SubTitle from "./title-sub.vue";
@Component({
  components: {
    Title,
    SubTitle,
  },
})
export default class DetailContentJifentiao extends Vue {
  @Prop()
  private content: any;
  @Prop()
  private index: any;
  @Prop()
  private source: any; //dialog,审核修改弹框;renkouxue,人口学和受试者信息;
  private get c() {
    const data = JSON.parse(JSON.stringify(this.content));
    if (typeof data.value === "string") {
      data.value = 0;
    }
    return data;
  }
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }
  private valueChange(val: any) {
    if (this.source === "dialog") {
      this.$emit("updateDialog", this.c);
    } else {
      this.$emit("update", this.c);
    }
  }
  private formatTooltio(val: any) {
    return val;
  }
}
